// extracted by mini-css-extract-plugin
module.exports = {"togglebutton":"styles_togglebutton__12QvF","toggleicon":"styles_toggleicon__2DQVI","toggleinput":"styles_toggleinput__1k2yz"};